module.exports = __webpack_public_path__ + "static/media/users-medical.9bf4cfa1.svg";